<template>
  <div class="form-group mb-0 repeatable-group">
    <label>Groepen &amp; prijzen</label>

    <div class="container-repeatable-elements">
      <div v-for="(item, index) in types" :key="index">
        <Type
          v-model="types[index]"
          :index="index"
          @on-remove="removeType(index)"
        />
      </div>
    </div>

    <button
      type="button"
      class="btn btn-primary mt-2 btn-sm ml-1"
      @click="addType"
    >
      + Nieuw item
    </button>
  </div>
</template>

<script>
import Type from "./Type.vue";

export default {
  components: { Type },
  name: "List",
  props: {
    value: {
      type: Array,
    },
  },
  data() {
    return {
      types: this.value,
    };
  },
  methods: {
    addType() {
      this.types.push({
        type: "",
        required: false,
        prices: [],
        default_price: 0,
        name: "",
        weekdays: [],
      });
    },
    removeType(index) {
      this.types.splice(index, 1);
    },
  },
};
</script>